import { DA_COMM_EMOTE, DA_OFF_EMOTE } from './types';
import { OfficialEmoteViewer, CommunityEmoteViewer, } from './viewer/ReactViewer';
export var typeMapper = function () {
    var _a;
    return (_a = {},
        _a[DA_OFF_EMOTE] = {
            component: OfficialEmoteViewer,
            elementType: 'inline',
        },
        _a[DA_COMM_EMOTE] = {
            component: CommunityEmoteViewer,
            elementType: 'inline',
        },
        _a);
};
//# sourceMappingURL=typeMapper.js.map